import { render, staticRenderFns } from "./TahliyeEmri56Taslak.vue?vue&type=template&id=147845f3"
import script from "./TahliyeEmri56Taslak.vue?vue&type=script&lang=ts"
export * from "./TahliyeEmri56Taslak.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports